import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { map } from 'rxjs/operators';
import * as _ from 'underscore';

const filters = {
  categories: {
    type: 'produkty',
    name: 'Kategoria produktu',
    open: false,
    items: [],
  },
  gama: {
    type: 'gamy',
    name: 'Gama',
    open: false,
    items: [],
  },
  type: {
    name: 'Typ Produktu',
    open: false,
    items: [],
  },
  effect: {
    type: 'efekty',
    name: 'Efekt',
    items: [],
  },
};

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  filters;

  products;
  allProducts$;

  constructor(private _data: DataService) {}

  loadData(params) {
    return new Promise((resolve, reject) => {
      this._data
        .invoke(`/platform/products`, 'get', params)
        .pipe(
          map((res) => {
            const products = res.data;
            products.forEach((product) => {
              product.categories.forEach((category) => {
                const categoryIndex = _.findLastIndex(
                  filters.categories.items,
                  { id: category.id }
                );
                if (categoryIndex === -1) {
                  filters.categories.items.push(category);
                }
              });
              if (product.effects[0]) {
                const effectIndex = _.findLastIndex(filters.effect.items, {
                  id: product.effects[0].id,
                });
                if (effectIndex === -1) {
                  filters.effect.items.push(product.effects[0]);
                }
              }
              if (product.gama) {
                const gamaIndex = _.findLastIndex(filters.gama.items, {
                  id: product.gama.id,
                });
                if (gamaIndex === -1) {
                  filters.gama.items.push(product.gama);
                }
              }
              if (product.type && product.type.id) {
                const typeIndex = _.findLastIndex(filters.type.items, {
                  id: product.type.id,
                });
                if (typeIndex === -1) {
                  filters.type.items.push(product.type);
                }
              }
            });

            return products;
          })
        )
        .subscribe((res) => {
          this.products = res;
          this.filters = filters;
          resolve(true);
        });
    });
  }

  getProducts(filter) {
    const products = [];
    this.products.forEach((product) => {
      let returnItem = true;
      filter.categories.forEach((id) => {
        if (_.findLastIndex(product.categories, { id: id }) === -1) {
          returnItem = false;
        }
      });
      
      filter.effect.forEach((id) => {
        if (product.effects.findIndex((i) => i.id == id) === -1) {
          returnItem = false;
        }
      });
      filter.gama.forEach((id) => {
        if (product.gama.id !== id) {
          returnItem = false;
        }
      });
      filter.type.forEach((id) => {
        if (product.type.id !== id) {
          returnItem = false;
        }
      });
      if (returnItem) {
        products.push(product);
      }
    });
    return products;
  }

  clearFilters() {
    // tslint:disable-next-line: forin
    for (const key in filters) {
      filters[key].items.forEach((item) => {
        if (item.checked) {
          filters[key].checked = false;
        }
      });
    }
  }

  getStartFilters(clear = false) {
    const filter = {
      categories: [],
      gama: [],
      type: [],
      effect: [],
    };

    if (!clear) {
      // tslint:disable-next-line: forin
      for (const key in filters) {
        filters[key].items.forEach((item) => {
          if (item.checked) {
            filter[key].push(item.id);
          }
        });
      }
    }

    return filter;
  }

  getFilters(filter) {
    const products = this.getProducts(filter);
    this.clearFilters();

    if (products) {
      products.forEach((product) => {
        const reset = new Promise((resolve, reject) => {
          filters.categories.items.forEach((element) => {
            element.enable = false;
          });
          filters.effect.items.forEach((element) => {
            element.enable = false;
          });
          filters.gama.items.forEach((element) => {
            element.enable = false;
          });
          filters.type.items.forEach((element) => {
            element.enable = false;
          });
          resolve(true);
        });

        reset.then((res) => {
          product.categories.forEach((category) => {
            const categoryIndex = _.findLastIndex(filters.categories.items, {
              id: category.id,
            });
            filters.categories.items[categoryIndex].enable = true;
          });

          product.effects.forEach((effect) => {
            const effectIndex = _.findLastIndex(filters.effect.items, {
              id: effect.id,
            });
            if (effectIndex > -1)
              filters.effect.items[effectIndex].enable = true;
          });

          const gamaIndex = _.findLastIndex(filters.gama.items, {
            id: product.gama.id,
          });
          filters.gama.items[gamaIndex].enable = true;

          const typeIndex = _.findLastIndex(filters.type.items, {
            id: product.type.id,
          });
          filters.type.items[typeIndex].enable = true;
        });
      });
    }

    return filters;
  }
}
